function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import { parse, format } from "url";
var _templateString = /*#__PURE__*/new _WeakMap();
var _variables = /*#__PURE__*/new _WeakMap();
var _replacer = /*#__PURE__*/new _WeakMap();
var UrlTemplate = /*#__PURE__*/function () {
  function UrlTemplate(templateString, variables) {
    var _this = this;
    _classCallCheck(this, UrlTemplate);
    _classPrivateFieldInitSpec(this, _templateString, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _variables, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _replacer, {
      writable: true,
      value: function value(_match, capture) {
        if (Object.prototype.hasOwnProperty.call(_classPrivateFieldGet(_this, _variables), capture)) {
          return _classPrivateFieldGet(_this, _variables)[capture];
        }
        throw new Error("Unspecified template variable: ".concat(capture));
      }
    });
    _classPrivateFieldSet(this, _templateString, templateString);
    _classPrivateFieldSet(this, _variables, variables);
  }
  _createClass(UrlTemplate, [{
    key: "set",
    value: function set(key, value) {
      _classPrivateFieldGet(this, _variables)[key] = value;
    }
  }, {
    key: "toString",
    value: function toString() {
      var url = parse(_classPrivateFieldGet(this, _templateString));
      url.pathname = decodeURIComponent(url.pathname || '').replace(/\{([A-Za-z_$]+)\}/g, _classPrivateFieldGet(this, _replacer)).replace(/\/{2,}/g, '/');
      return format(url);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }]);
  return UrlTemplate;
}();
export { UrlTemplate as default };